export const emailValidationRegex =
  /^(?![._%+-])([a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*)@(?!(?:.*\.\.)|(?:-))([a-zA-Z0-9]+(-?[a-zA-Z0-9]+)*\.)+[a-zA-Z]{3,4}$/;
export const passwordRules = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{5,}$/;
export const phoneNumberRegex = /^\+?\d{10,15}$/;
export const faxNumberRegex = /^\+?[\d\s\-().]{7,20}$/;
export const websiteUrlRegex = /^(https?:\/\/)?([\w-]+\.)+[a-zA-Z]{2,}(\/[\w\-\.~:\/?#[\]@!$&'()*+,;=]*)?$/;
export const attachmentUrlRegex = /^(https?:\/\/)?([\w-]+\.)+[a-zA-Z]{2,}(\/[\w\-\.~:%\/?#[\]@!$&'()*+,;=]*)?$/;
export const zipCodeRegex = /^(\d{5}(-\d{4})?|[A-Z]\d[A-Z] \d[A-Z]\d)$/;
export const nameInputFilterRegex = /[^a-zA-Z\s'-]/g;

